// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1WrWy","title":"AfterFrontImage_title__CVBFw"};